module.exports = __webpack_public_path__ + "img/477d846f9bc657f40846fc91f293c97b-newLogo4.png";